import { Chakra } from "@airhelp/react-ui-components";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import config from "config/config";
import { useLanguage } from "contexts/LocalizationContext";
import useDeviceSize from "hooks/useDeviceSize";
import {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
} from "utils/menuUtils";
import FooterDesktop from "./FooterDesktop";
import FooterMobile from "./FooterMobile";

const { Box } = Chakra;

const Footer = () => {
  const language = useLanguage();
  const knowYourRights = useKnowYourRightsMenu(language);
  const products = useProductsMenu(language);
  const support = useSupportMenu(language);
  const company = useCompanyMenu(language);
  const legal = useLegalMenu(language);
  const imprint = useImprintMenu(language);
  const { isDesktopXl } = useDeviceSize();

  const menus = {
    knowYourRights,
    products,
    support,
    company,
    legal,
    imprint,
  };

  const footerComponent = isDesktopXl ? <FooterDesktop menus={menus} /> : <FooterMobile menus={menus} />;

  return (
    <StickyBottomBarTrigger type="second">
      <Box
        background="#f4f6f9"
        bgImage={
          isDesktopXl
            ? `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg?updatedAt=1627464403168)`
            : "none"
        }
        bgRepeat="no-repeat"
        bgPosition="100% -350%"
      >
        {footerComponent}
      </Box>
    </StickyBottomBarTrigger>
  );
};

export default Footer;
